import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20with%20warm%20golden%20and%20crimson%20light%20beams%20cutting%20through%20darkness%2C%20dramatic%20atmospheric%20fog%2C%20film%20noir%20aesthetic%2C%20abstract%20composition%2C%20intense%20moody%20atmosphere%2C%20minimalist%20abstract%20background%20with%20rich%20warm%20tones&width=1600&height=600&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-900/70 via-background-900/60 to-background-900/80"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto text-center px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          准备好加入特工世界了吗？
        </h2>
        <p className="text-sm md:text-base text-background-300 max-w-lg mx-auto mb-10 leading-relaxed">
          点击观看赤裸特工完整版，开启你的特工追剧之旅。动作、悬疑、谍战，一网打尽！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/watch-guide"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-accent-500 text-background-50 rounded-lg hover:bg-accent-600 transition-all duration-300 whitespace-nowrap shadow-lg shadow-accent-500/25"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观看
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-background-50/10 text-background-50 border border-background-50/30 rounded-lg hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap backdrop-blur-sm"
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}